import { useUserSelector } from './root';

export function useIsUserAuthenticatedSelector(): boolean {
  const user = useUserSelector();

  return user.data.isAuthenticated;
}
